import { useState, useEffect } from 'react';
var useFilterUserList = function (userList, deleted, positions, name) {
    var _a = useState([]), filteredUserList = _a[0], setFilteredUserList = _a[1];
    useEffect(function () {
        var filteredList = userList;
        if (deleted !== undefined) {
            filteredList = filteredList.filter(function (user) { return user.deleted === deleted; });
        }
        if (positions && positions.length > 0) {
            filteredList = filteredList.filter(function (user) { return positions.some(function (position) { return user.position.includes(position); }); });
        }
        if (name) {
            filteredList = filteredList.filter(function (user) { return user.name.toLowerCase().includes(name.toLowerCase()); });
        }
        setFilteredUserList(filteredList);
    }, [userList, deleted, positions, name]);
    return filteredUserList;
};
export default useFilterUserList;
